import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function useVisitorTracking() {
  const location = useLocation();
  const trackedPages = useRef(new Set());

  useEffect(() => {
    const trackVisit = async () => {
      const page = location.pathname;
      
      // Avoid tracking the same page multiple times in the same session
      if (trackedPages.current.has(page)) return;
      trackedPages.current.add(page);

      try {
        await fetch(`${API_URL}/api/track/visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: page,
            referrer: document.referrer || null
          })
        });
      } catch {
        // Visitor tracking is non-critical - never disrupt user experience
      }
    };

    trackVisit();
  }, [location.pathname]);
}
